import axios from "axios";

import { api } from "@/services/api";
import { DeleteResponse, PaginatedResponse } from "@/types";
import {
  AddSeoSlug,
  SeoSlug,
  SeoSlugListFilters,
  UpdateSeoSlug,
} from "@/types/seo-slug";

const ECOM_BASE_URL =
  import.meta.env.VITE_ECOM_BASE_URL || "http://localhost:5173";
const SITEMAP_SECRET = import.meta.env.VITE_SITEMAP_SECRET || "";

export class SeoSlugRepository {
  async findAll(
    filters: SeoSlugListFilters,
  ): Promise<PaginatedResponse<SeoSlug>> {
    const response = await api.get("/v1/admin/seo-slugs", { params: filters });

    return response.data;
  }

  async add(data: AddSeoSlug): Promise<SeoSlug> {
    const response = await api.post("/v1/admin/seo-slugs", data);

    return response.data;
  }

  async update(data: UpdateSeoSlug): Promise<SeoSlug> {
    const { id, ...payload } = data;
    const response = await api.patch(`/v1/admin/seo-slugs/${id}`, payload);

    return response.data;
  }

  async delete(id: string): Promise<DeleteResponse> {
    const response = await api.delete(`/v1/admin/seo-slugs/${id}`);

    return response.data;
  }

  async regenerateSitemap(): Promise<{ generated: string[]; productCount: number }> {
    const response = await axios.post(
      `${ECOM_BASE_URL}/api/generate-sitemap`,
      {},
      { headers: { "x-sitemap-secret": SITEMAP_SECRET } },
    );

    return response.data;
  }
}
